export const environment = {
	production: true,
	cloudinaryBaseUrl: 'https://res.cloudinary.com/whydonate/image/upload/',
	apiUrl: 'https://whydonate-production-api.appspot.com/api/v1/',
	ACCOUNT_API_V2: 'https://account.whydonate.dev/',
	ACCOUNTING_API: 'https://accounting.whydonate.dev/',
	DONATION_API_V2: 'https://donation.whydonate.dev/',
	FUNDRAISER_API_V2: 'https://fundraiser.whydonate.dev/',
	CUSTOM_DOMAIN_API_V2: 'https://customdomain.whydonate.dev/',
	homeUrl: 'https://whydonate.com',
	helpDeskUrl: 'https://helpdesk.whydonate.com',
	domain: 'whydonate.com',
	donation_url: 'https://donation.whydonate.dev',
	wallet_url: 'https://wallet.whydonate.dev/',
	project_url: 'https://project.whydonate.dev/',
	search_url: 'https://search.whydonate.dev/',
	fundraiser_url: 'https://fundraiser.whydonate.dev/',
	fundraiser_features_url: 'https://fundraiser.whydonate.dev/',
	ADMIN_API: "https://admin.whydonate.dev",
	PASSWORD_ENCRYPTION_KEY: 'mMNIzrZQuZl01Pas9S4Z/MchYS3y0kkd4+IA0+pJ3Hg=',
	SENTRY_AUTH_TOKEN:
		'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',
	STRIPE_PUBLISHABLE_KEY_EU: 'pk_live_fP1JyZSzMvSvc7ZrjvLNPl5o',
	STRIPE_PUBLISHABLE_KEY_US:
		'pk_live_51MyULDEJyxSpFgVbtOm5bFk1QCFJgBBm78YP0dKQXLpZQiSsGORSjDSfwd6dRhVPME4eBa6ipopkM5lZ1aLVMa7D00nANT6Kpc',
	OFFICIAL_DOMAINS: [
		'whydonate.com',
		'whydonate.in',
		'localhost:4200',
		'whydonate.work',
		'whydonate.cc',
		'main.whydonate-web-portal.pages.dev',
		'master.whydonate-web-portal.pages.dev',
		'develop.whydonate-web-portal.pages.dev',
		'features.whydonate-web-portal.pages.dev',
		'features2.whydonate-web-portal.pages.dev',
	],
};
